import React, { useRef, useState } from 'react';
import emailjs from 'emailjs-com';
import { Form, Button } from 'react-bootstrap';
import './ContactForm.css';

const ContactForm = () => {
  const form = useRef();
  const [messageFilled, setMessageFilled] = useState(false);
  const handleMessageChange = (e) => {
    setMessageFilled(e.target.value.trim().length > 0);
  }



  const sendEmail = (e) => {
    e.preventDefault();

    const el = form.current;
    // Populate the template variables the form has no visible field for.
    el.elements.namedItem('title').value =
      el.elements.namedItem('name').value.trim() || 'Website Inquiry';
    el.elements.namedItem('time').value = new Date().toLocaleString('en-US', {
      dateStyle: 'medium',
      timeStyle: 'short',
    });

    emailjs.sendForm(
      'service_enb97sj',     // from EmailJS dashboard
      'template_aahp1at',   // EmailJS template ID (Contact Us)
      form.current,
      '6XA_f8KR96zPsHuJP'      // your EmailJS public key
    ).then(
      (result) => {
        console.log('Email sent:', result.text);
        alert('Message sent successfully!');
        el.reset();
        setMessageFilled(false);
      },
      (error) => {
        console.error('Email error:', error.text);
        alert('Failed to send message.');
      }
    );
  };

  return (
    <Form ref={form} onSubmit={sendEmail} className="contact-form">
      {/* Hidden fields for template variables {{title}} and {{time}} */}
      <input type="hidden" name="title" />
      <input type="hidden" name="time" />

      <Form.Group controlId="formName">
        <Form.Label>Name</Form.Label>
        <Form.Control type="text" name="name" placeholder="Enter your name" required />
     </Form.Group>

      <Form.Group controlId="formEmail">
        <Form.Label>Email</Form.Label>
        <Form.Control type="email" name="email" placeholder="Enter your email" required />
      </Form.Group>

      <Form.Group controlId="formMessage">
        <Form.Label>Message</Form.Label>
        <Form.Control as="textarea" name="message"
         rows={5} placeholder="Your Message" required 
         onChange={handleMessageChange} 
          style={{
          backgroundColor: messageFilled ? '#0A2A52' : '#021126',
          transition: 'background-color 0.3s ease',
        }}

         />
      </Form.Group>

      <Button type="submit" className='submit-button' disabled={!messageFilled}>Send</Button>
    </Form>
  );
};

export default ContactForm;